import React, { PureComponent } from 'react';
import styled from 'styled-components';

import isFinite from 'lodash/isFinite';
import getKey from 'lodash/get';

import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Popover from 'antd/lib/popover';
import Message from 'antd/lib/message';
import Modal from 'antd/lib/modal';

import InputText from 'hive-admin/src/components/Input/Input';

import tests from '../../../helpers/tests';

import Types from '../../../modules/types';

const { viewerIsAdminAndDoesNotHavePermission } = tests;

const {
  CONSTANTS: {
    ShippingStorage,
  },
} = Types;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 5px;
`;

const StockPopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  .ant-btn {
    margin-top: 12px;
  }
`;

const CenterAlignedInput = styled(Input)`
  text-align: center;
`;

export default class FieldStock extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      value: undefined,
      stockCurrent: undefined,
      stockUpdateInfo: null,
      stockUpdateMessage: null,
    };
  }

  getStockCurrent() {
    const { stockCurrent } = this.state;
    const { type, data, parentData } = this.props;
    return (
      !isFinite(stockCurrent)
      ? getKey(parentData, `stock.${data._id}.${type}`, 0)
      : stockCurrent
    );
  }

  getStockUpdateData(value) {
    const stockNew = parseInt(value, 10);
    if (!isFinite(stockNew)) {
      throw new Error('Invalid stock specified');
    }
    const stockCurrent = this.getStockCurrent();
    const stockDelta = stockNew - stockCurrent;
    const stockUpdateMessage = (
        stockDelta > 0
      ? `Add ${Math.abs(stockDelta)}`
      : stockDelta < 0
      ? `Remove ${Math.abs(stockDelta)}`
      : null
    );
    if (!stockUpdateMessage) {
      throw new Error('Stock not changed');
    }
    return {
      stockNew,
      stockCurrent,
      stockDelta,
      stockUpdateMessage,
    };
  }

  handleStockUpdateInfoDismiss = () => this.setState({
    stockUpdateInfo: null,
  })

  handleUpdate = () => {
    try {
      const {
        stockNew,
        stockCurrent,
        stockDelta,
      } = this.getStockUpdateData(this.state.value);
      const { type, client, data, parentData } = this.props;
      client.request({
        method: 'POST',
        url: `products/${parentData._id}/variations/${data._id}/stock`,
        data: { type, value: stockDelta },
      })
      .then(({ data: { value: stockNewRemote } }) => {
        if (isFinite(stockNewRemote)) {
          const stockNewRemoteDelta = stockNewRemote - stockNew;
          const stockCurrentRemote = stockCurrent + stockNewRemoteDelta;
          const newState = {
            value: undefined,
            stockUpdateInfo: null,
            stockUpdateMessage: null,
            stockCurrent: stockNewRemote,
          };
          if (stockNewRemoteDelta !== 0) {
            newState.stockUpdateInfo = [
              [
                'Previous available stock level for this item has changed',
                `from ${
                  stockCurrent
                } to ${
                  stockCurrentRemote
                } while you were on this page.`,
              ],
              [
                'This usually happens when a new order has been placed',
                'in the meantime.',
              ],
              [
                'To keep your stock state and product availability',
                'consistend we have adjusted the final stock value',
                'to correct for this change.',
                `Your final stock level is set to ${
                  stockNewRemote
                } instead of ${
                  stockNew
                }.`,
              ],
            ];
          }
          this.setState(newState);
          Message.success('Stock updated!');
        } else {
          throw new Error('Cannot update stock at this time');
        }
      })
      .catch((error) => {
        Message.error(error.message);
      });
    } catch (error) {
      Message.error(error.message);
    }
  }

  handleChange = (event) => {
    // eslint-disable-next-line prefer-destructuring
    const value = event.target.value;
    this.setState(() => {
      try {
        const { stockUpdateMessage } = this.getStockUpdateData(value);
        return { value, stockUpdateMessage };
      } catch (error) {
        return { value, stockUpdateMessage: null };
      }
    });
  }

  handleAddonAfterVisibleChange = (visible) => {
    this.setState({ visible: !!visible });
  }

  renderAddonAfter() {
    const { data: { __NEW } } = this.props;
    const { visible, stockUpdateInfo } = this.state;
    const content = <span style={{ cursor: 'pointer' }}>+/-</span>;
    if (stockUpdateInfo) {
      return content;
    }
    return (
      <Popover
        title="Update Stock"
        onVisibleChange={this.handleAddonAfterVisibleChange}
        visible={visible}
        content={(
          <StockPopoverWrapper>
            {
                __NEW
              ? (
                  <>
                    This product variation is new.
                    <br />
                    Save product first in order to update its stock.
                  </>
                )
              : (
                  this.props.type === ShippingStorage.WAREHOUSE
                  && (!this.props.viewer || this.props.viewer.role !== 'ADMIN')
                )
              ? (
                  <>
                    Warehouse stock level is managed
                    <br />
                    by the Packman team.
                  </>
                )
              : (
                  <>
                    <CenterAlignedInput
                      size="small"
                      placeholder="New stock level"
                      onChange={this.handleChange}
                      value={this.state.value}
                    />
                    <Button
                      size="small"
                      onClick={this.handleUpdate}
                      disabled={!this.state.stockUpdateMessage}
                      block
                    >
                      {this.state.stockUpdateMessage || 'Update'}
                    </Button>
                  </>
                )
            }
          </StockPopoverWrapper>
        )}
      >
        {content}
      </Popover>
    );
  }

  render() {
    const { type, viewer } = this.props;
    const { stockUpdateInfo } = this.state;
    const value = this.getStockCurrent();
    return (
      <>
        <InputText
          value={value}
          align="right"
          addonBefore={`${Types.SHIPPING_STORAGE_LABELS_MAP[type]}`}
          addonAfter={
            type === 'LOCAL'
            || !viewerIsAdminAndDoesNotHavePermission(
              'productsStockUpdate'
            )({ viewer })
            ? this.renderAddonAfter()
            : null
          }
        />
        <Modal
          title="Stock update info"
          visible={!!stockUpdateInfo}
          onOk={this.handleStockUpdateInfoDismiss}
          closable={false}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          {
            stockUpdateInfo
            ? stockUpdateInfo.map(
                // eslint-disable-next-line react/no-array-index-key
                ((text, i) => <p key={i}>{text.join(' ')}</p>)
              )
            : null
          }
        </Modal>
      </>
    );
  }
}

function FieldStocks(props) {
  const {
    parentData: {
      storeStorageOptions = [],
    } = {},
  } = props;
  // console.log('storeStorageOptions:', storeStorageOptions);
  return (
    <Wrapper key="stocks">
      {
        Types.SHIPPING_STORAGE.reduce(
          (agr, storage) => {
            if (storeStorageOptions.includes(storage)) {
              agr.push(
                <FieldStock
                  key={storage}
                  type={storage}
                  data={props.data}
                  parentData={props.parentData}
                  viewer={props.viewer}
                  client={props.client}
                />
              );
            }
            return agr;
          },
          [],
        )
      }
    </Wrapper>
  );
}

export const fieldStocks = ['FieldReact', {
  name: '__stocks',
  virtual: [],
  // eslint-disable-next-line arrow-body-style, no-unused-vars
  renderContent: (props, field) => {
    return (
      <FieldStocks {...props} />
    );
  },
}];
